



























































































import { Component, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { getAutocompleteFilter } from "@/lib/utility/filter";
import { CurrencyEnum } from "@/lib/enum/currency.enum";
import { TotalLossType } from "@/lib/enum/total-loss-type.enum";
import { IAppraisal } from "@/models/appraisal.entity";
import LineItemsForm from "@/components/repair-estimate/LineItemsForm.vue";

@Component({
  components: { LineItemsForm }
})
export default class AppraisalForm extends mixins(RulesMixin) {
  @Prop({ required: true }) value!: IAppraisal;
  @Prop({ type: Boolean, default: false }) disabled!: boolean;
  @Prop({ type: Boolean, default: false }) showDate!: boolean;

  readonly CurrencyEnum = CurrencyEnum;
  readonly TotalLossType = TotalLossType;
  readonly getAutocompleteFilter = getAutocompleteFilter;
}
